import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';

import {
  ContentProvider,
  PageContainer,
  PageHeader,
} from '../content/components';
import {
  ColumnBlock,
  ColumnContent,
  ContentSection,
} from '../layout/components';
import { LanguageSelector, EmailSignupForm, PlayTestForm } from './components';
import styles from '../../styles';

const StyledColumnContent = styled(ColumnContent)`
  h2 {
    color: ${styles.color.CHARCOAL};
    font-size: 4.25rem !important;
    ${styles.media.phone` font-size: 2.833333333333333rem;`};
  }
`;

const StyledTitle = styled.h2`
  color: ${styles.color.CHARCOAL} !important;
  font-size: 4.25rem !important;
  ${styles.media.phone` font-size: 2.833333333333333rem;`};
`;

class GenericPage extends Component {
  static propTypes = {
    breakpoint: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  };

  render() {
    const { breakpoint, slug } = this.props;

    return (
      <ContentProvider
        slug={`static-pages/${slug}`}
        render={({ title, page, typography, translation_links }) => (
          <PageContainer typography={typography}>
            <PageHeader mainImage={page.main_image} />

            <ContentSection>
              <ColumnBlock>
                {breakpoint !== 'tablet' && (
                  <StyledColumnContent paddingTop="3.125rem">
                    <h2>{title}</h2>
                  </StyledColumnContent>
                )}
              </ColumnBlock>
              <ColumnBlock columns={2}>
                <ColumnContent
                  paddingTop={breakpoint !== 'phone' ? '4.25rem' : 0}
                  paddingBottom="4.5rem"
                >
                  {breakpoint === 'tablet' && (
                    <React.Fragment>
                      <StyledTitle>{title}</StyledTitle>
                    </React.Fragment>
                  )}
                  {translation_links && (
                    <LanguageSelector items={translation_links} slug={slug} />
                  )}
                  <div
                    id="page-content"
                    dangerouslySetInnerHTML={{ __html: page.body }}
                  />
                  {slug === 'keep-up-to-date' && (
                    <EmailSignupForm breakpoint={breakpoint} />
                  )}
                  {slug === 'playtest' && (
                    <PlayTestForm breakpoint={breakpoint} />
                  )}
                </ColumnContent>
              </ColumnBlock>
            </ContentSection>
          </PageContainer>
        )}
      />
    );
  }
}

const mapStateToProps = (state, { match: { params } }) => {
  const { breakpoint } = state.layout;
  const { slug } = params;
  return {
    breakpoint,
    slug,
  };
};

export default withRouter(connect(mapStateToProps, null)(GenericPage));



// WEBPACK FOOTER //
// ./src/modules/pages/GenericPage.js